import { render } from "./serviceDesc.vue?vue&type=template&id=7ac7e871&scoped=true"
import script from "./serviceDesc.vue?vue&type=script&lang=js"
export * from "./serviceDesc.vue?vue&type=script&lang=js"

import "./serviceDesc.vue?vue&type=style&index=0&id=7ac7e871&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac7e871"]])

export default __exports__